module.exports = __webpack_public_path__ + "ptc_nakagawa_B2.115f2fdc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_B2.jpg
// module id = spXG
// module chunks = 0